import { Injectable } from '@angular/core';
import * as joint from '@clientio/rappid';

/**
 * Service to register and retrieve flowchart paper instances by widget ID.
 * Used for PDF export functionality.
 */
@Injectable({ providedIn: 'root' })
export class FlowchartPaperRegistryService {
  private papers = new Map<string, joint.dia.Paper>();

  register(flowchartWidgetId: string, paper: joint.dia.Paper): void {
    this.papers.set(flowchartWidgetId, paper);
  }

  unregister(flowchartWidgetId: string): void {
    this.papers.delete(flowchartWidgetId);
  }


  get(flowchartWidgetId: string): joint.dia.Paper | undefined {
    return this.papers.get(flowchartWidgetId);
  }


  getAll(): Map<string, joint.dia.Paper> {
    return new Map(this.papers);
  }

  clear(): void {
    this.papers.clear();
  }
}

